import { ChangeEnum, ConfirmedEnum, CountingStateEnum, OperateEnum, OrderEnum } from "@/types/inventory";
import { CountOrderStateEnum } from "@/types/inventoryV2";
import i18next from "i18next";

export const opTypes = [
  { value: OperateEnum.PENDING, label: i18next.t('inventory.inv'), colorKey: 'gold' },
  { value: OperateEnum.TRANSACTION, label: i18next.t('inventory.trade'), colorKey: 'purple' },
  { value: OperateEnum.DISPATCH, label: i18next.t('inventory.transfer'), colorKey: 'cyan' },
  { value: OperateEnum.TEMPORARY, label: i18next.t('inventory.temporary'), colorKey: 'magenta' },
  { value: OperateEnum.PICKING, label: i18next.t('warehouse.sourcesPick'), colorKey: 'orange' },
  { value: OperateEnum.IN_RETURN, label: i18next.t('warehouse.sourcesInReturn'), colorKey: 'volcano' },
  { value: OperateEnum.OUT_RETURN, label: i18next.t('warehouse.sourcesOutReturn'), colorKey: 'green' },
]

export const changeTypes = [
  { value: ChangeEnum.IN, label: i18next.t('inventory.inbound'), colorKey: 'blue' },
  { value: ChangeEnum.OUT, label: i18next.t('inventory.outbound'), colorKey: 'red' }
]

export const orderTypes = [
  { value: OrderEnum.SCAN, label: i18next.t('inventory.scanOrder'), colorKey: 'geekblue' },
  { value: OrderEnum.COUNT, label: i18next.t('inventory.inputOrder'), colorKey: 'green' }
]

export const confirmTypes = [
  { value: ConfirmedEnum.NOTCONFIRM, label: i18next.t('inventory.beConfirmed'), colorKey: 'red' },
  { value: ConfirmedEnum.CONFIRM, label: i18next.t('inventory.confirmed'), colorKey: 'blue' }
]

export const countingStatus = [
  { value: CountingStateEnum.PENDING, label: i18next.t('inventory.invInProgress'), colorKey: 'red' },
  { value: CountingStateEnum.COUNTING, label: i18next.t('inventory.genertDifferences'), colorKey: 'blue' },
  { value: CountingStateEnum.IN, label: i18next.t('inventory.cpletDifIn'), colorKey: 'gold' },
  { value: CountingStateEnum.OUT, label: i18next.t('inventory.cpletDifOut'), colorKey: 'magenta' },
  { value: CountingStateEnum.DONE, label: i18next.t('inventory.cplet'), colorKey: 'green' }
]

export const countingStatusV2 = [
  { value: CountOrderStateEnum.COUNTING, label: i18next.t('inventory.invInProgress'), colorKey: 'blue' },
  { value: CountOrderStateEnum.DONE, label: i18next.t('inventory.cplet'), colorKey: 'green' }
]

export const scanAddMax = {
  scanMax: 10, // 单次出入库扫描单最大数量
  barcodeMax: 500, // 单个扫描单 条码最大数量 
}